import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {DataSource, SelectionModel} from '@angular/cdk/collections';

import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {AppMatCustomAction} from './mat-table-core/app-mat-custom-action';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractDataSource} from '../../table-datasouces/abstract.datasource';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {ToastService} from 'angular-toastify';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {MatSort, SortDirection} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {ContentRowField} from '../content-row/content-row.component';
import {HttpParams} from "@angular/common/http";

@Component({
  moduleId: module.id,
  selector: 'app-mat-table-generator',
  templateUrl: './mat-table-generator.component.html',
  styleUrls: ['./mat-table-generator.component.css'],

  changeDetection: ChangeDetectionStrategy.Default,
})

export class MatTableGeneratorComponent implements OnInit, AfterViewInit {
  constructor(
    private _toastService: ToastService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  @Input() columns: any[];
  @Input() dataSource: any;
  @Input() customQueryParams;
  @Input() filters = new DateTableFilter();
  @Input() useEmbededFilter = true;
  @Input() saveFilters = false;
  @Input() showOnlyPaginator = false;
  @Input() pageSizeOptions = [20, 50, 100, 500, 1000, 2500];

  @Input() tableName;
  @Input() customActions: AppMatCustomAction[] = null;

  @Input() viewEnabled = true;
  @Input() editEnabled = true;

  @Input() viewLink: (row: any) => string;
  @Input() editLink: (row: any) => string;

  @Input() rowClassCallback: (row: any) => string;

  @Input() deleteEnabled = true;
  @Input() multiselectEnabled = true;
  @Input() undoDeleteEnabled = true;
  @Input() searchEnabled = true;

  @Input() defaultSortField = 'id';
  @Input() defaultSortDirection: SortDirection = 'desc';

  @Output() clearingFilters = new EventEmitter<any>();

  @Input() dialogRemoveText = '';

  headers: any[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild(MatTable, { static: true }) matTable: MatTable<Element>;
  selection = new SelectionModel(true, []);



  get singleCustomActions(): AppMatCustomAction[] {
    return (this.customActions ? this.customActions.filter(x => !x.multiselectAction) : []);
  }

  get multiselectCustomActions(): AppMatCustomAction[] {
    return (this.customActions ? this.customActions.filter(x => x.multiselectAction) : []);
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    this.sort.active = this.defaultSortField;
    this.sort.direction = this.defaultSortDirection;

    this.dataSource.paginator = this.paginator;

    this.sort.sortChange.subscribe(() => {
      this.saveTableFilters();
    });

    this.paginator.page.subscribe(() => {
      this.saveTableFilters();
    });




    if (this.dataSource.itemsSubject) {
      this.dataSource.itemsSubject.subscribe(() => {
        this.selection.clear();
      });
    }

    if (this.multiselectEnabled) {
      this.columns.unshift({ columnDef: 'select', header: '', cell: null });
    }
    if (this.canView() || this.canEdit() || this.canDelete() || this.singleCustomActions && this.singleCustomActions.length > 0) {
      this.columns.push({ columnDef: 'actions', header: 'Actions', cell: null });
    }

    this.headers = this.columns.map(c => c.columnDef);
    if (this.tableName != null) {
      if (this.saveFilters) {
        const savedFilters = JSON.parse(sessionStorage.getItem(this.tableName));
        if (savedFilters != null) {
          for (const k in this.filters) {
            if (this.filters.hasOwnProperty(k) && savedFilters.hasOwnProperty(k)) {
              this.filters[k] = savedFilters[k];
            }
          }
          if (savedFilters.sortField) {
            this.sort.active = savedFilters.sortField;
          }
          if (savedFilters.sortDirection) {
            this.sort.direction = savedFilters.sortDirection;
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    this.applyFilter();
  }

  canView() {
    return this.viewLink && this.viewEnabled;
  }

  canEdit() {
    return this.editLink && this.editEnabled;
  }

  canDelete() {
    return this.dataSource.delete && this.deleteEnabled;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  saveTableFilters() {

    if (this.tableName) {
      this.filters.sortField = this.sort.active;
      this.filters.sortDirection = this.sort.direction;
      this.filters.page = this.paginator.pageIndex;
      this.filters.pageSize = this.paginator.pageSize;
      //this.filters.someAdditionalData = this

      sessionStorage.setItem(this.tableName, JSON.stringify(this.filters));
    }
  }

  applyFilter() {
    this.paginator.pageIndex = 0;
    this.saveTableFilters();

    if (this.dataSource instanceof AbstractDataSource) {
      this.dataSource.filter = this.filters;
    } else if (this.dataSource instanceof MatTableDataSource) {
      this.dataSource.filter = this.filters.str;
    }
  }

  clearFilter(dontClearSomeAdditionalData = false) {
    for (const k in this.filters) {
      if (this.filters.hasOwnProperty(k)) {
        if( dontClearSomeAdditionalData && k == 'someAdditionalData' ){
          // dont clear
        }else{
          this.filters[k] = null;
        }

      }
    }
    this.applyFilter();
    this.clearingFilters.emit();
  }

  refreshTable() {
    this.matTable.renderRows();
  }

  private deleteRowsFromTable(list: number[]): any[] {
    const rows = list.map(item => {
      const idx = this.dataSource.data.findIndex(x => x.id == item);
      const row = this.dataSource.data[idx];

      this.dataSource.data.splice(idx, 1);

      return row;
    });
    this.matTable.renderRows();
    this.dataSource.decrementLength(list.length);
    return rows;
  }

  private recoverRowsFromTable(list: any[]) {
    this.dataSource.data.push(...list);
    this.dataSource.incrementLength(list.length);
    this.matTable.renderRows();
  }

  deleteMany(list: number[]) {
    if (list.length == 0) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { text: this.dialogRemoveText } });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.dataSource.deleteMany(list).subscribe(() => {
          const recoveryList = this.deleteRowsFromTable(list);
          this.selection.clear();
          this.cd.detectChanges();

          const caption = 'Object deleted: ' + list.length.toString();
          const config: MatSnackBarConfig = {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          };

          if (this.undoDeleteEnabled) {
            this.snackBar.open(caption, 'Undo', config).onAction().subscribe(() => {
              this.dataSource.restoreMany(list).subscribe(() => {
                this.recoverRowsFromTable(recoveryList);
              });
            });
          } else {
            this.snackBar.open(caption, null, config);
          }
        });
      }
    });
  }

  deleteSelected() {
    this.deleteMany(this.selection.selected.map(d => d.id));
  }


  deleteRow(row: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { text: this.dialogRemoveText } });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.dataSource.delete(row.id).subscribe(() => {
          const recoveryList = this.deleteRowsFromTable([row.id]);
          this.selection.clear();
          this.cd.detectChanges();

          const caption = 'Object deleted';
          const config: MatSnackBarConfig = {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          };

          if (this.undoDeleteEnabled) {
            // TODO find a possibility to do this with toaster service
            this.snackBar.open('Object deleted', 'Undo', config).onAction().subscribe(() => {
              this.dataSource.restore(row.id).subscribe(() => {
                this.recoverRowsFromTable(recoveryList);
              });
            });
          } else {
            this.snackBar.open(caption, null, config);
          }
        });
      }
    });
  }

  doubleClick(row: any) {
    if (this.viewLink) {
      this.router.navigate([this.viewLink(row)], { relativeTo: this.route, queryParams: this.customQueryParams });
    } else if (this.editLink) {
      this.router.navigate([this.editLink(row)], { relativeTo: this.route });
    }
  }

  getClassesArray(column, row) {
    const classes = [];
    if (column.class) {
      classes.push(...column.class.split(' '));
    }
    if (column.getClass && typeof column.getClass === 'function') {
      const c = column.getClass(row);
      classes.push(...c.split(' '));
    }
    return classes;
  }

  getCellStyle(column: ContentRowField<any>, row: any) {
    const style = {
      color: null,
      backgroundColor: null,
    };
    if ( column.cellColor && column.cellColor(row) ) {
      style.color = column.cellColor(row);
    }
    if ( column.cellBackgroundColor && column.cellBackgroundColor(row) ) {
      style.backgroundColor = column.cellBackgroundColor(row);
    }

    return style;
  }
}
